import type { GetClByUserCodeRequestProps } from '@services/api/users/types'
import type { GetClByUserCodePayloadProps } from '../context/types'

export const parseGetClByUserCodePayload = (formData: GetClByUserCodePayloadProps) => {
  const payload: GetClByUserCodeRequestProps = {
    routeParams: {
      userCode: formData.userCode!
    },
    bodyParams: {
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType,
      sortType: formData.sortType,
      codeFilter: formData.code ? formData.code.toString() : null,
      profitCenterFilter: formData.profitCenter ? formData.profitCenter.toString() : null,
      buFilters: formData.bu ? (formData.bu === 'Todos' ? null : [formData.bu]) : null,
      segmentFilters: formData.segment ? (formData.segment === 'Todos' ? null : [formData.segment]) : null,
      boardOfDirectorsFilters: formData.boardOfDirectors
        ? formData.boardOfDirectors === 'Todos'
          ? null
          : [formData.boardOfDirectors]
        : null
    }
  }

  return payload
}
